import React, { Fragment } from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { cartService } from 'services/CartService';
import Translate from 'components/Translate';
import { IProductData } from 'interfaces/IProductData';
import { enPaymentType } from 'enums/enPaymentType';

interface IState extends IStateBase {
  cart: IProductData;
}

export default class AskAddressMessage extends BaseComponent<IState> {

  componentDidMount() {
    this.observeState({ cart: null }, cartService.getCart());
  }

  getMessage = () => {
    const { cart } = this.state;

    console.log(cart.paymentType);

    if (cart.paymentType === enPaymentType.FREE) {
      return (
        <Fragment>
          <h1 className='title theme-label' id='thankyou-title'><Translate term='Já é quase seu!' /></h1>
          <p className='label theme-label'>
            <Translate term='O Download está quase pronto, complete o breve formulário abaixo para continuar' />
          </p>
        </Fragment>
      );
    }

    return (
      <Fragment>
        <h1 className='title theme-label' id='thankyou-title'><Translate term='Obrigado pela Compra!' /></h1>
        <p className='label theme-label'>
          <Translate term='O seu pagamento está em processamento, complete o breve formulário abaixo para continuar' />
        </p>
      </Fragment>
    );
  }

  render() {
    if (!this.state) {
      return null;
    }

    return (
      <Fragment>
        {this.getMessage()}
      </Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/AskAddress/AskAdressMessage/index.tsx